import Auth from '@@types/Auth';

import { URLS } from '~/constants';
import InterTenantApi from '~/stores/providers/InterTenantApi';
import { getResult } from '~/utils/apiUtil';

import * as packageJson from '../../../../package.json';

class InterTenantCommonApi {
  constructor(private api: InterTenantApi) {}

  fetchAuth = (): Promise<Auth> => {
    return this.api.ignoreErrorRequester
      .get(`${URLS.V4_API}/members/me?v=${packageJson.version}`)
      .then(getResult) as Promise<Auth>;
  };
}

export default InterTenantCommonApi;
